import * as React from "react";
const SvgFiRrShirtLongSleeve = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shirt-long-sleeve_svg__a)">
      <path
        fill="#062147"
        d="M20.814 1.195C19.337.402 17.782 0 16.19 0H7.81C6.218 0 4.662.402 3.185 1.195 1.221 2.25 0 4.335 0 6.636V18c0 1.654 1.346 3 3 3h1.424A5 5 0 0 0 9 24h6a5 5 0 0 0 4.576-3H21c1.654 0 3-1.346 3-3V6.636c0-2.301-1.221-4.387-3.186-5.441M14.893 2a3.09 3.09 0 0 1-2.894 2 3.09 3.09 0 0 1-2.893-2zm7.106 16c0 .551-.448 1-1 1h-1V7a1 1 0 1 0-2 0v12c0 1.654-1.346 3-3 3h-6c-1.654 0-3-1.346-3-3V7a1 1 0 0 0-2 0v12h-1c-.551 0-1-.449-1-1V6.636c0-1.563.817-2.973 2.131-3.679a7.9 7.9 0 0 1 2.897-.907A5.09 5.09 0 0 0 11.999 6a5.09 5.09 0 0 0 4.972-3.95c.988.106 1.96.404 2.898.907C21.183 3.663 22 5.073 22 6.636z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shirt-long-sleeve_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShirtLongSleeve;
